module.exports = __webpack_public_path__ + "a15ce80fd0042c53a3b30168e8105d6b.jpg";